module.exports = __webpack_public_path__ + "static/media/grow-responsive.1d32f866.png";